 <template>
	<div id="quizDetailContainer">
		<div>
            <header class="mdc-top-app-bar position-init">
                <div class="mdc-top-app-bar__row">
                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                        <a class="material-icons mdc-top-app-bar__navigation-icon" @click="onClose()">close</a>
                    </section>
                    
                    <section class="mdc-top-app-bar__section title">
                        <div class="mdc-top-app-bar__title">
                            {{$t('1090')}}
                            <!-- Quiz -->
                        </div>                
                    </section>

                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                        <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                    </section>
                </div>
            </header>
			<section id="quizDetailContents" v-if="currentTimelineContents.quiz">
				<span class="t-subtitle4">
                    {{currentTimelineContents.quiz.question}}
                </span>
				<div class="item-list">
                    <div class="question-choices">
                        <div class="t-body1 choice" 
                            v-for="(view, index) in currentTimelineContents.quiz.views" 
                            :key="index"  
                            :class="{ 'on': !submitStatus && index===userAnswer, 'correct': submitStatus && index===userAnswer && correctStauts, 'incorrect':  submitStatus && index===userAnswer && !correctStauts }"  
                            @click="!submitStatus ? setUserAnawer(index) : null"
                            >
                            <div class="choice-text">
                                <div class="correct-icon" v-if="index===userAnswer && correctStauts === true  && submitStatus === true"></div>
                                <div class="incorrect-icon" v-else-if="index===userAnswer && correctStauts === false && submitStatus === true"></div>
                                <div class="number-circle" v-else>{{index+1}}</div>
                                <div class="choice-text">
                                    {{view.text}}
                                </div>
                            </div>
                            
                        </div>
                    </div> 
					
                    
				</div>
                <!-- <div>
                    {{currentTimelineContents}}
                </div> -->
                <div class="submit">
                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big"  @click="answerSubmit()" :disabled="!checkAnswer" v-if="!submitStatus">
                            {{$t('1091')}}
                        <!-- Submit -->
                    </button>

                    <button class="mdc-button mdc-button--raised btn-red w-full btn-big"  @click="confirm()" v-if="submitStatus">
                            {{$t('994')}}
                        <!-- confirm -->
                    </button>
                    
                </div>
				
			</section>
		</div>
	</div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 퀴즈 컨텐츠 상세 컴포넌트(my learning lesson study - timeline quiz contents detail component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
    props: ['currentTimelineContents'],
    data() {
        return {
            userAnswer: -1,
            submitStatus: false,
            correctStauts: false
        }
    },
        
    computed: {
        // 답안 체크 여부 확인(Check answer check)
        checkAnswer() {
            return  this.userAnswer >= 0 ? true : false
        }
    },
    
    methods: {
        // 퀴즈 상세 닫기(close Quiz Detail)
        onClose() {
            this.$emit('closeQuizDetail');
        },

        // 답안 설정(set answer)
        setUserAnawer(answer) {
            this.userAnswer = answer
        },

        // 정답 제출(submit answer)
        answerSubmit() {
            // console.log(this.userAnswer);
            this.submitStatus = true            
            let alertParams = null
            if (this.currentTimelineContents.quiz.views[this.userAnswer].correct) {
                this.correctStauts = true
            }else {
                this.correctStauts = false
            }
        },

        confirm() {
            this.onClose()
        }
    }
}
</script>